import { useEffect, useState } from "react";
import pkg from "../../../package.json";

export const useVersions = () => {
  const [loading, setLoading] = useState<boolean>();
  const [versions, setVersions] = useState<any[]>();

  useEffect(() => {
    setLoading(true);

    fetch(`${process.env.REACT_APP_API?.replace("graphql", "versions")}`)
      .then((res) => res.json())
      .then(({ microservices }) => {
        microservices.push({
          name: pkg.name,
          active: true,
          version: pkg.version,
          react: pkg.dependencies.react,
        });

        setVersions(microservices);

        return microservices;
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return {
    versions,
    loading,
  };
};
